import React from "react";
import { ControlDataGridColumnProps } from "../../../../assets/vfx/controls/components/datagrid/controlDataGrid";
import {
  SearchDto,
  SearchOperator,
} from "../../../../assets/utils/lib/searchDto";
import {
  defaultSearchQuery,
  GRID_ACTION_TYPES,
} from "../../../../assets/types";
import Control from "../../../../assets/vfx/controls/control";
import { LoadingIndicator } from "../../../../assets/vfx";
import { PlanService } from "../planService";
import { IControlStyles, useControlStyles } from "../../../../assets/layouts";
import {
  createActionColumn,
  createLayoutOptions,
} from "../../../../assets/configuration/gridConfig";
import { GridSubscriptionPlanDto } from "../../../../services/dto";

interface SubscriptionPlanGridProps {
  planId: string;
  onCustomEvent?: (actionType: string, dataId: string) => void;
}

const DATA_ID_FIELD = "id";

const createGridColumns = (): ControlDataGridColumnProps[] => [
  {
    data: DATA_ID_FIELD,
    title: "ID",
    visible: false,
    columnType: "number",
    alignment: "right",
  },
  {
    data: "name",
    title: "Name",
    visible: true,
    columnType: "text",
    alignment: "left",
    sortable: true,
    width: "18%",
  },
  {
    data: "description",
    title: "Description",
    visible: true,
    columnType: "text",
    alignment: "left",
    width: "34%",
  },
  {
    data: "publishedDate",
    title: "Published Date",
    visible: true,
    columnType: "date",
    alignment: "left",
    width: "18%",
  },
  {
    data: "activationDate",
    title: "Activation Date",
    visible: true,
    columnType: "date",
    alignment: "left",
    width: "18%",
  },
];

const SubscriptionPlanGrid = (props: SubscriptionPlanGridProps) => {
  const styles: IControlStyles = useControlStyles();
  const searchQuery: SearchDto = {
    ...defaultSearchQuery,
    filters: [
      {
        field: "planId",
        operator: SearchOperator.Equal,
        value: props.planId,
      },
    ],
  };

  const subscriptionPlanGridQuery =
    PlanService.gridSubscriptionPlanQuery(searchQuery);

  const subscriptions: GridSubscriptionPlanDto[] =
    subscriptionPlanGridQuery.data?.result ?? [];
  const hasData: boolean = subscriptions.length > 0;
  const gridColumns: ControlDataGridColumnProps[] = createGridColumns();
  const actionColumn = createActionColumn(styles, DATA_ID_FIELD, [
    GRID_ACTION_TYPES.DEACTIVATE,
  ]);
  const layoutOptions = createLayoutOptions(hasData);

  if (subscriptionPlanGridQuery.isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <Control.DataGrid
      key={JSON.stringify(searchQuery)}
      dataId={DATA_ID_FIELD}
      cols={gridColumns}
      data={subscriptions}
      actionCol={actionColumn}
      layoutOptions={layoutOptions}
      onCustomEvent={props.onCustomEvent}
    />
  );
};

export default SubscriptionPlanGrid;
